(function () {
  const BG = '#f3efe6';   // background color
  const FG = '#754d2a';   // text & border color

  // Create the <style> tag we want to keep inserting
  function makeStyleTag() {
    const styleEl = document.createElement('style');
    styleEl.textContent = `
      /* Button container */
      .group.relative.inline-flex.h-9.items-center {
        background: ${BG} !important;
        border: 1px solid ${FG} !important;
        border-radius: 9999px !important;
        color: ${FG} !important;
      }
      /* Background layer */
      .absolute.inset-y-0.-z-10.rounded-max { background: ${BG} !important; }
      /* Text + icons */
      .text-white { color: ${FG} !important; }
      .text-white svg, button svg { color: ${FG} !important; fill: currentColor !important; stroke: currentColor !important; }
      /* Hover */
      .group:hover, .group:focus-visible { opacity: .9 !important; }
    `;
    return styleEl;
  }

  function applyInlineFallbacks(shadowRoot) {
    const btn = shadowRoot.querySelector('button.group');
    if (btn) {
      btn.style.background = BG;
      btn.style.border = `1px solid ${FG}`;
      btn.style.borderRadius = '9999px';
      btn.style.color = FG;
    }
    const bgDiv = shadowRoot.querySelector('div.absolute');
    if (bgDiv) bgDiv.style.background = BG;
  }

  // Attach style AND keep it there even if the web component re-renders
  function styleOne(el) {
    if (!el || !el.shadowRoot) return;
    if (el.__styledByTheme) return;

    function ensureStyled() {
      // If our style tag got blown away, re-add it
      const already = Array.from(el.shadowRoot.querySelectorAll('style'))
        .some(s => s.textContent && s.textContent.includes('Button container'));
      if (!already) {
        el.shadowRoot.appendChild(makeStyleTag());
        applyInlineFallbacks(el.shadowRoot);
      }
    }

    // Initial attach
    ensureStyled();

    // Observe the shadowRoot itself for internal re-renders
    const shadowMo = new MutationObserver(ensureStyled);
    shadowMo.observe(el.shadowRoot, { childList: true, subtree: true });

    el.__styledByTheme = true;
  }

  function scanAll() {
    document.querySelectorAll('shop-follow-button').forEach(styleOne);
  }

  function init() {
    scanAll();

    // Watch for new components added later (AJAX/Theme Editor)
    const docMo = new MutationObserver(scanAll);
    docMo.observe(document.documentElement, { childList: true, subtree: true });

    // Theme editor events
    document.addEventListener('shopify:section:load', scanAll);
    document.addEventListener('shopify:section:unload', scanAll);
    document.addEventListener('shopify:section:select', scanAll);
    document.addEventListener('shopify:section:deselect', scanAll);
    document.addEventListener('shopify:block:select', scanAll);
    document.addEventListener('shopify:block:deselect', scanAll);

    // Page transition frameworks (if used)
    window.addEventListener('page:load', scanAll);
    document.addEventListener('turbo:load', scanAll);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) scanAll();
    });

    // Re-assert for a few seconds after load
    let ticks = 0;
    const interval = setInterval(() => {
      scanAll();
      if (++ticks > 10) clearInterval(interval);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();